import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { errorMessage } from '../shared/helpers/messages-popup';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          error?.error?.details || 
          error?.error?.message ||
          'Error';
        errorMessage(errorMsg);
        return throwError(() => errorMsg);
      }),
    );
  }
}
